<template>
    <div class="field flex">
        <span class="field-title">{{ control.data.settings_question }}</span>
        <template v-if="control.data.type !== 'text'">
            <radio-control
                :user-answer="userMeta[control.name]"
                :control-name="control.name"
                :options="control.data.options"
            />
        </template>
        <template v-else>
            <text-control
                :user-answer="userMeta[control.name]"
                :control-name="control.name"
            />
        </template>
    </div>
</template>

<script>
import RadioControl from './ProfileControls/RadioControl.vue';
import TextControl from './ProfileControls/TextControl.vue';

export default {
    components: {
        RadioControl,
        TextControl,
    },
    props: {
        control: {
            type: Object,
            default: () => ({}),
        },
        userMeta: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
